export const fmtNum = (n) => new Intl.NumberFormat("it-IT", { maximumFractionDigits: 2 }).format(n);
export const KIND_LABEL = { mandata: "Mandata", ripresa: "Ripresa", altro: "Altra rete" };
export const STORAGE_KEY = "cb_tech_passcode";
export const API = process.env.REACT_APP_BACKEND_URL;

export const logError = (...args) => {
    if (process.env.NODE_ENV !== "production") console.error(...args);
};

// Parse a section string like "500x300", "Ø 250", "DN 200" -> {a,b,d} in mm.
export function parseSection(text) {
    if (!text) return { a: null, b: null, d: null };
    const t = String(text).trim();
    const mRect = t.match(/(\d{2,4})\s*[xX×*]\s*(\d{2,4})/);
    if (mRect) return { a: +mRect[1], b: +mRect[2], d: null };
    const mCirc = t.match(/(?:Ø|Ø|∅|D[Nn]?\s*)\s*(\d{2,4})/);
    if (mCirc) return { a: null, b: null, d: +mCirc[1] };
    return { a: null, b: null, d: null };
}

// m² of sheet metal per metre of duct, given the section dimensions in mm.
export function areaPerMetre({ a, b, d }) {
    if (a && b) return (2 * (a + b)) / 1000;
    if (d) return (Math.PI * d) / 1000;
    return 0;
}

export function computeArea(section, length_m) {
    const per = areaPerMetre(parseSection(section));
    return Math.round(per * (Number(length_m) || 0) * 100) / 100;
}

let rowSeq = 0;
export const withKeys = (rows) => (rows || []).map((r) => ({ ...r, _key: `row-${++rowSeq}` }));

export function extractErrorMessage(status, data) {
    if (!data) return `Errore ${status}`;
    if (typeof data === "string") return data;
    if (typeof data.detail === "string") return data.detail;
    if (Array.isArray(data.detail)) return data.detail.map((d) => d.msg || JSON.stringify(d)).join(" · ");
    return `Errore ${status}`;
}
